export const RACES_COUNT = 9;
export const MAX_SECONDS_PAGE = 30;